export const AssetQuery =
    `{
    _type,
    alt,
    showVideoFrame,
    asset[] {
        ...,
        _key,
        _type,
        asset {
            _ref,
            _type,
        },
        crop,
        hotspot,
        _type == "video" => {
            "assetUrl": asset->{url},
        }
    }
}` 